import './JobQueue.scss';

import FilterListIcon from '@mui/icons-material/FilterList';
import { TablePagination, Typography } from '@mui/material';
import _ from 'lodash';
import AddAndEditJob from 'pages/common/AddAndEditJob';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAllListData } from 'services/CommonServices';
import { useAppSelector } from 'store/hooks';
import { jobFilterData } from 'store/reducers/UserReducer';
import {
  USER_CUSTOMER_DATA,
  USER_JOB_FILTER_DATA,
  USER_JOB_TAB_DATA,
  USER_RELOAD,
} from 'store/types/UserTypes';
import { MASTER_ENDPOINT } from 'utils/Constant';

import JobQueueFilter from './filter';
import JobQueueHeader from './JobQueueHeader';
import JobQueueTable from './JobQueueTable';
import { User } from './utils';

const staticParam = {
  order: 'desc',
  reload: true,
  skip: 0,
  sortby: '',
  take: 50,
};
const JobQueue: React.FC = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [searchValue, setSearchValue] = useState('');
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const dispatch = useDispatch();
  const [openfilter, setOpenFilter] = useState(false);
  const [tabSearch, setTabSearch] = React.useState<string>('1');
  const [workStatusList, setWorkStatusList] = React.useState<any>([]);
  const [users, setUsers] = useState<User[]>([]);
  const [loading, setLoading] = React.useState<any>(true);
  const [params, setParams] = React.useState<any>({});
  const [tableInfo, setTableInfo] = React.useState<any>({
    list: [],
    total: 0,
  });
  const [openAddJob, setOpenAddJob] = useState(false);
  const {
    userInfo,
    reload,
    customerInfo,
    customerFilter,
    companyFilter,
    jobTab,
    jobFilter,
  }: any = useAppSelector((store: any) => store.userLogin);

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
    setTabFun(
      tab === 'all' ? 0 : tab === 'my' ? 1 : tab === 'overdue' ? 10 : 11,
    );
  };

  const handleSearchChange = (value: string) => {
    setSearchValue(value);
    setParams((prev) => ({
      ...prev,
      skip: 0,
      take: prev.take,
    }));
  };

  const getSkillAndCustomer = (customerStatus: boolean) => {
    getAllListData(
      MASTER_ENDPOINT.Customer +
        `?status=true&order=asc&sortby=name${
          customerStatus
            ? `&publish=${String(
                jobTab === 3 ? '' : jobTab !== 4 ? true : false,
              )}&jobStatus=${
                [1].includes(jobTab)
                  ? 'published'
                  : jobTab === 2
                  ? 'matched,filled,lost,others'
                  : jobTab === 4
                  ? 'draft'
                  : ''
              }&jobUserId=${String(
                userInfo.roleId === 5 ? (jobTab !== 0 ? userInfo.id : '') : '',
              )}&deletedStatus=${jobTab === 3 ? 'true' : 'false'}`
            : ''
        }`,
    ).then((resp: any) => {
      if (!_.isEqual(customerInfo, resp?.data)) {
        dispatch({
          payload: resp.data,
          type: USER_CUSTOMER_DATA,
        });
      }
    });
  };
  const handleAddJob = () => {
    getSkillAndCustomer(false);
    setOpenAddJob(true);
  };

  const handleSortClick = () => {
    console.log('Sort clicked');
    // Implement sort functionality
  };

  const handleRowSelect = (id: string) => {
    setSelectedRows((prev) => {
      if (prev.includes(id)) {
        return prev.filter((rowId) => rowId !== id);
      } else {
        return [...prev, id];
      }
    });
    console.log('Selected rows:', selectedRows, id);
  };

  const handleSelectAll = (selected: boolean) => {
    if (selected) {
      // Select all visible rows (you might want to implement select all across all pages)
      setSelectedRows([]);
    } else {
      setSelectedRows([]);
    }
  };

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ) => {
    setParams((prev) => ({
      ...prev,
      skip: newPage * Number(prev.take),
    }));
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setParams((prev) => ({
      ...prev,
      skip: 0,
      take: parseInt(event.target.value, 10),
    }));
  };

  const tabs = [
    { id: 'all', label: 'All Jobs' },
    { id: 'my', label: 'My Job' },
    { id: 'overdue', label: 'Overdue' },
    { id: 'closed', label: 'Closed' },
  ];
  const setTabFun = React.useCallback(
    (num: any) => {
      dispatch({
        payload: num,
        type: USER_JOB_TAB_DATA,
      });
    },
    [dispatch],
  );
  const resetFilter = React.useCallback(() => {
    if (!_.isEqual(jobFilterData, jobFilter)) {
      dispatch({
        type: USER_RELOAD,
      });
      jobFilter.skillData = [];
      dispatch({
        payload: { ...jobFilterData },
        type: USER_JOB_FILTER_DATA,
      });
    }
    setOpenFilter(false);
  }, [dispatch, jobFilter]);

  const handleClose1 = () => {
    setOpenAddJob(false);
  };
  const getWorkStatus = () => {
    getAllListData(MASTER_ENDPOINT.WorkStatus + '?status=true').then(
      (resp: any) => {
        setWorkStatusList(resp?.data);
      },
    );
  };
  const userData = () => {
    getAllListData(
      `${MASTER_ENDPOINT.Admins}?sortby=name&order=ASC&roleId=5&search=&skip=&take=&organizationId=&status=true`,
    )
      .then((res) => {
        setUsers(res?.data);
      })
      .catch((err) => console.log({ err }));
  };
  const getJobData = async () => {
    setLoading(true);
    setTableInfo({
      list: [],
      total: 0,
    });
    let url = `${MASTER_ENDPOINT.Jobs}?id=&order=${String(
      params.order,
    )}&sortby=${String(params.sortby)}&skip=${String(
      params.skip,
    )}&take=${String(params.take)}&publish=${String(
      jobTab === 3 ? '' : jobTab !== 4 ? true : false,
    )}&status=${
      [1].includes(jobTab)
        ? 'published'
        : jobTab === 2
        ? 'matched,filled,lost,others'
        : jobTab === 4
        ? 'draft'
        : ''
    }&userId=${String(
      userInfo.roleId === 5 ? ([1].includes(jobTab) ? userInfo.id : '') : '',
    )}&deletedStatus=${jobTab === 3 ? 'true' : ''}`;
    if (jobFilter.applyFilter) {
      let skillId = '';
      if (jobFilter?.skillData && jobFilter?.skillData?.length) {
        jobFilter?.skillData.map((item: any) => {
          skillId += item?.id + ',';
        });
      }
      if (skillId) {
        skillId = skillId.replace(/,\s*$/, '');
      }
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      url += `&workType=${jobFilter?.workLocation}&jobTitle=${
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        jobFilter?.title
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      }&location=${jobFilter?.location}&workStatus=${jobFilter?.workStatus}${
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        tabSearch !== '1'
          ? // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            `&salaryFrom=${jobFilter?.salaryFrom}&salaryTo=${jobFilter?.salaryTo}`
          : `&payRangeFrom=${
              jobFilter.payRangeFrom ? parseInt(jobFilter.payRangeFrom) : ''
            }&payRangeTo=${
              jobFilter.payRangeTo ? parseInt(jobFilter.payRangeTo) : ''
            }`
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      }&skillId=${skillId}&assignedTo=${jobFilter?.assignedTo}&assignedBy=${
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        jobFilter?.assignedBy
      }&isApply=true`;
    }
    if (customerFilter && customerFilter !== 'all') {
      url += '&customerId=' + customerFilter;
    }
    if (jobTab === 0) {
      url += `&organizationId=${String(companyFilter)}`;
    }
    if ([10, 11].includes(jobTab)) {
      url += `&screen=${jobTab === 10 ? 'overdue' : 'closed'}`;
    }
    await getAllListData(url)
      .then((resp) => {
        setLoading(false);
        setTableInfo({
          list: resp.data,
          total: resp?.total,
        });
      })
      .catch((err: any) => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    if (Object.keys(params).length) {
      getJobData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  React.useEffect(() => {
    if (Object.keys(params).length) {
      setParams({ ...staticParam, reload: !params.reload });
    } else {
      setParams(staticParam);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobTab, reload, customerFilter, companyFilter]);

  React.useEffect(() => {
    getWorkStatus();
    userData();

    return () => {
      setTabFun(0);
      resetFilter();
    };
  }, [resetFilter, setTabFun]);

  console.log('Render JobQueue');
  return (
    <Typography component={'div'} className="job-queue-container">
      {/* Header Component */}
      <JobQueueHeader
        searchValue={searchValue}
        onSearchChange={handleSearchChange}
        onAddJob={handleAddJob}
        onSortClick={handleSortClick}
      />

      {/* Table Component */}
      <div className="job-queue-table-container">
        <div className="job-queue-table-container-content">
          <div className="job-queue-table-container-tabs">
            {/* Tabs */}
            <div className="job-queue-tabs">
              {tabs.map((tab) => (
                <Typography
                  key={tab.id}
                  className={`job-queue-tab ${
                    activeTab === tab.id ? 'active' : ''
                  }`}
                  onClick={() => handleTabChange(tab.id)}
                  sx={{
                    color: '#656565 !important',
                    cursor: 'pointer',

                    display: 'inline-block',

                    fontFamily: 'Red Hat Display Medium !important',
                    // fontFamily: 'Red Hat Display Regular',
                    fontSize: '13px',
                    fontWeight: 'medium',
                    marginRight: '8px',
                    padding: '8px 16px',
                    textDecoration: 'none',
                  }}>
                  {tab.label}
                </Typography>
              ))}
            </div>
            <JobQueueTable
              data={tableInfo?.list || []}
              selectedRows={selectedRows}
              onRowSelect={handleRowSelect}
              onSelectAll={handleSelectAll}
              loading={loading}
              users={users}
            />
          </div>

          <div
            className="job-queue-table-container-filters"
            onClick={() => setOpenFilter(true)}>
            <FilterListIcon />
            <Typography
              component="div"
              sx={{
                color: '#181D1F',
                fontFamily: 'Red Hat Display Regular',
                fontSize: '13px',
                fontWeight: 400,
                rotate: '90deg',
              }}>
              Filters
            </Typography>
          </div>
        </div>

        {/* Pagination Component */}
        <div className="job-queue-pagination-container">
          <TablePagination
            sx={{
              '& .MuiTablePagination-select': {
                fontFamily: 'Red Hat Display Medium !important',
              },
              '& p': {
                fontFamily: 'Red Hat Display Medium !important',
              },
            }}
            component="div"
            count={tableInfo?.total || 0}
            page={Number(params.skip) / Number(params.take)}
            onPageChange={handlePageChange}
            rowsPerPage={params.take ? parseInt(params.take) : 0}
            rowsPerPageOptions={[50, 100, 150, 200, 250]}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </div>
      </div>

      {/* Filters Component */}
      {
        <JobQueueFilter
          openfilter={openfilter}
          setOpenFilter={setOpenFilter}
          tabSearch={tabSearch}
          jobFilter={jobFilter}
          workStatusList={workStatusList}
          users={users}
          setTabSearch={setTabSearch}
          resetFilter={resetFilter}
        />
      }

      {/* Add Job Modal */}
      {openAddJob && (
        <AddAndEditJob
          workStatusList={workStatusList}
          open={openAddJob}
          editId={null}
          editRow={null}
          scroll={'body'}
          onClose={handleClose1}
        />
      )}
    </Typography>
  );
};

export default JobQueue;
